import { render, staticRenderFns } from "./ModalAdditionalForm.vue?vue&type=template&id=7428d456"
import script from "./ModalAdditionalForm.vue?vue&type=script&lang=js"
export * from "./ModalAdditionalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports